import Vue from 'vue'
import Sounds from '@/js/sounds'
import { clone } from '@/js/utils'

// === STATE =====================================================================================
const default_state = {
	screen: 'home',
	shake: false,
	settings: false,
	config: {
		tuto: true,
		audio: true,
		quick_battle: false
	}
}

const state = clone(default_state)






// === GETTERS =====================================================================================
const getters = {
	app(state) { return state },
}







// === ACTIONS =====================================================================================
const actions = {

	init_app({ commit }) {
		Sounds.init()

		let config = localStorage.getItem('fighters-config')
		if (config) {
			try {
				config = JSON.parse(config)
				commit('EDIT_APP_STATE', { config })
			} catch(e) {
				console.log(e)
			}
		}
	},


	edit_config({ state, commit }, data) {
		const config = { ...state.config, ...data }
		commit('EDIT_APP_STATE', { config })

		localStorage.setItem('fighters-config', JSON.stringify(config))
	}

}



// === MUTATIONS =====================================================================================
const mutations = {

	EDIT_APP_STATE(state, data) {
		for (var i in data) {
			Vue.set(state, i, data[i])
		}
	}

}

export default { state, getters, actions, mutations }
